import EfScrollAni from '@/efscrollani';
import { useProductStore } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import StatusA from './StatusA';
import StatusB from './StatusB';
import StatusC from './StatusC';
import PhProduct from './PhProduct';
import './index.scss';
import getLocal from '@/app/utils/i18n';

export default function ExampleProductA() {
    const { pageStatus } = useProductStore();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    const { locale } = getLocal();

    return (
        <div className="page-product">
            {locale === 'ph' && (
                <>
                    <PhProduct />
                </>
            )}
        </div>
    );
}
